module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "locationManagementEditModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), (_vm.locationData.LocationId) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.locationData.LocationId))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showLocationHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showLocationHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showLocationHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0090))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0021))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputClient"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputClient",
      "name": "inputClient",
      "placeholder": _vm.lang.L0023,
      "disabled": _vm.selectedLocation > 0,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.getLocationProperties(_vm.locationData.ClientId)
      }
    },
    model: {
      value: (_vm.locationData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "ClientId", $$v)
      },
      expression: "locationData.ClientId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                        " + _vm._s(client.ClientName) + "\n                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputClient')),
      expression: "inputHasError('inputClient')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationImporter"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0088) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputLocationImporter",
      "name": "inputLocationImporter",
      "placeholder": _vm.lang.L0023,
      "required": ""
    },
    model: {
      value: (_vm.locationData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "ImporterGuid", $$v)
      },
      expression: "locationData.ImporterGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                        " + _vm._s(importer.ImporterName) + "\n                      ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLocationImporter')),
      expression: "inputHasError('inputLocationImporter')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputStoreId"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0024) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationStoreId),
      expression: "locationData.LocationStoreId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputStoreId",
      "name": "inputStoreId",
      "required": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputStoreId')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationStoreId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputStoreId')),
      expression: "inputHasError('inputStoreId')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationName"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0025) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationName),
      expression: "locationData.LocationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationName",
      "name": "inputLocationName",
      "maxlength": "50",
      "required": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLocationName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLocationName')),
      expression: "inputHasError('inputLocationName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0026))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAddress),
      expression: "locationData.LocationAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.locationData.LocationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAddress2),
      expression: "locationData.LocationAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.locationData.LocationAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDistrict"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationCounty),
      expression: "locationData.LocationCounty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDistrict",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.locationData.LocationCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationCounty", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationCity),
      expression: "locationData.LocationCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.locationData.LocationCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.changedCountry(_vm.locationData.LocationCountry)
      }
    },
    model: {
      value: (_vm.locationData.LocationCountry),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationCountry", $$v)
      },
      expression: "locationData.LocationCountry"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "regionSelect",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.currentRegions.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationState_Region),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationState_Region", $$v)
      },
      expression: "locationData.LocationState_Region"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentRegions), function(region) {
    return _c('option', {
      key: region.Region,
      domProps: {
        "value": region.Region
      }
    }, [_vm._v("\n                        " + _vm._s(region.RegionName) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0032))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "timeZoneSelect",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.currentTimeZones.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationTimeZoneId),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationTimeZoneId", $$v)
      },
      expression: "locationData.LocationTimeZoneId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentTimeZones), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                        " + _vm._s(tz.TimeZoneName) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportCountryCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0084))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputExportCountryCode",
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.changedExportCountryCode()
      }
    },
    model: {
      value: (_vm.locationData.LocationExportDefaultCountryCode),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationExportDefaultCountryCode", $$v)
      },
      expression: "locationData.LocationExportDefaultCountryCode"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportLanguageCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0085))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "exportLanguageSelect",
    staticClass: "form-control",
    attrs: {
      "id": "inputExportLanguageCode",
      "disabled": _vm.currentExportLanguages.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationExportDefaultLanguageCode),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationExportDefaultLanguageCode", $$v)
      },
      expression: "locationData.LocationExportDefaultLanguageCode"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.currentExportLanguages), function(language) {
    return _c('option', {
      key: language.LanguageCode,
      domProps: {
        "value": language.LanguageCode
      }
    }, [_vm._v("\n                        " + _vm._s(language.LanguageName) + "\n                      ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPostalCode),
      expression: "locationData.LocationPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.locationData.LocationPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhone"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPhone),
      expression: "locationData.LocationPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhone",
      "name": "inputPhone"
    },
    domProps: {
      "value": (_vm.locationData.LocationPhone)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhone')),
      expression: "inputHasError('inputPhone')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0079))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationFax),
      expression: "locationData.LocationFax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputFax",
      "name": "inputFax"
    },
    domProps: {
      "value": (_vm.locationData.LocationFax)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationFax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFax')),
      expression: "inputHasError('inputFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0080))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhotoURL"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPhotoURL),
      expression: "locationData.LocationPhotoURL"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "id": "inputPhotoURL",
      "name": "inputPhotoURL"
    },
    domProps: {
      "value": (_vm.locationData.LocationPhotoURL)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhotoURL')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPhotoURL", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhotoURL')),
      expression: "inputHasError('inputPhotoURL')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0081))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportMail"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationExportEmail),
      expression: "locationData.LocationExportEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputExportMail",
      "name": "inputExportMail",
      "multiple": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationExportEmail)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputExportMail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationExportEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputExportMail')),
      expression: "inputHasError('inputExportMail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0082))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportMailName"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationExportEmailName),
      expression: "locationData.LocationExportEmailName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputExportMailName"
    },
    domProps: {
      "value": (_vm.locationData.LocationExportEmailName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationExportEmailName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputStatus"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationStatusId),
      expression: "locationData.LocationStatusId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.locationData, "LocationStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, _vm._l((_vm.locationStatusList), function(status, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(status) + "\n                      ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLatitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationLatitude),
      expression: "locationData.LocationLatitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-90",
      "max": "90",
      "id": "inputLatitude"
    },
    domProps: {
      "value": (_vm.locationData.LocationLatitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationLatitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLatitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLatitude')),
      expression: "inputHasError('inputLatitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLongitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationLongitude),
      expression: "locationData.LocationLongitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-180",
      "max": "180",
      "id": "inputLongitude"
    },
    domProps: {
      "value": (_vm.locationData.LocationLongitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationLongitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLongitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLongitude')),
      expression: "inputHasError('inputLongitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGeocodeSource"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationGeocodeSource),
      expression: "locationData.LocationGeocodeSource"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputGeocodeSource"
    },
    domProps: {
      "value": (_vm.locationData.LocationGeocodeSource)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationGeocodeSource", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingRemarks",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseRemarks",
      "aria-expanded": "false",
      "aria-controls": "collapseRemarks"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0052))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseRemarks",
      "role": "tabpanel",
      "aria-labelledby": "headingRemarks"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAdditionalInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0053))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAdditionalInfo),
      expression: "locationData.LocationAdditionalInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "maxlength": "2000",
      "id": "inputAdditionalInfo"
    },
    domProps: {
      "value": (_vm.locationData.LocationAdditionalInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAdditionalInfo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationData.CustomProperties),
      expression: "locationData.CustomProperties"
    }],
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustProp",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustProp",
      "aria-expanded": "false",
      "aria-controls": "collapseCustProp"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0054))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationData.CustomProperties),
      expression: "locationData.CustomProperties"
    }],
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustProp",
      "role": "tabpanel",
      "aria-labelledby": "headingCustProp"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.L0055) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.L0056) + "\n                      ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.locationData.CustomProperties), function(property) {
    return _c('tr', {
      key: property.ID
    }, [_c('td', [_vm._v(_vm._s(property.Name))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Value),
        expression: "property.Value"
      }],
      staticClass: "form-control text-center textarea-custom-properties autoExpand",
      attrs: {
        "rows": "1",
        "maxlength": "1000",
        "type": "text"
      },
      domProps: {
        "value": (property.Value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "Value", $event.target.value)
        }
      }
    })])])])
  }), 0)])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.L0057))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.L0058) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "id": "location-management-dialog-save-button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Locations_Update') &&
        _vm.selectedLocation > 0
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('locationManagementEditModal')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.L0059) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd21c294","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationManagement/LocationManagementEditModal.vue
// module id = 1721
// module chunks = 1